/* NOTE: it seems that the "click-scroll" problem is not satisfied by careful scrolling
    - I found 1 workaround that handles the menu link headers when active
      -- need to provide a function to hide all menu link headers IF (or):
                    aboutMe link is clicked
                    top link is clicked


*/




import $ from 'jquery';
global.jQuery = require('jquery');

$(function(){

  console.log("inside navResets ready function");



  var aboutMe = $('._AboutMeClicked'),
      top = $('._topClicked'),
      headerApps = $('.menu_link_header_Apps');

  // whenever the aboutMe or top links are clicked

  aboutMe.on('click', function(){
    console.log("clicked _AboutMe");

    // FIRST, make sure scrolling has stopped
    $(document).on('scrollstop', function(){

      // for each instance
      headerApps.each(function(index){
        // if it exists
        if ($(this)[index]) {

          // create a variable for greater ease
          let thisStyle = $(this)[index].style

          console.log("checking thisStyle", thisStyle);

          // if display is NOT none
          if (thisStyle.display !== 'none') {
            // reset the whole thing to original
            thisStyle.display = 'none';
            thisStyle.opacity = '0';
            thisStyle.top = '-5vh';
          }

        }
      })
    })
    // if ($('.menu_link_header_Apps'))

  });
  top.on('click', function(){
    console.log("clicked _top");


  });









/*
  // responsive 1

  $('#menu_link_Apps_r1').on('click', function(){
    console.log("inside .on()");

    console.log('checking menu link motion graphics...', ($('#menu_link_MotionGraphics_r1')[0].style));

    // reset motion graphics
    // $('#menu_link_MotionGraphics_r1')[0].style.left = '7vw';


  })
*/



})



// WEBPACK FOOTER //
// ./src/js_animations/navResets.js